import { render, staticRenderFns } from "./InvoiceSection.vue?vue&type=template&id=35de1fca"
import script from "./InvoiceSection.vue?vue&type=script&lang=js"
export * from "./InvoiceSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports